module.exports = __webpack_public_path__ + "media/images/icon/icons8-Form-9dd3d62293f85224b6cbbde35cddb3f1.png";